import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

/* Layout */
import Layout from '../views/layout/Layout'

/**
 * hidden: true                   if `hidden:true` will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu, whatever its child routes length
 *                                if not set alwaysShow, only more than one route under the children
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noredirect           if `redirect:noredirect` will no redirct in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
    title: 'title'               the name show in submenu and breadcrumb (recommend set)
    icon: 'svg-name'             the icon show in the sidebar,
  }
 **/
export const constantRouterMap = [
  {path: '/login', component: () => import('@/views/login/index'), hidden: true},
  {path: '/404', component: () => import('@/views/404'), hidden: true},
  {
    path: '',
    component: Layout,
    redirect: '/home',
    children: [{
      path: 'home',
      name: 'home',
      component: () => import('@/views/home/index'),
      meta: {title: '首页', icon: 'home'}
    }]
  }
]

export const asyncRouterMap = [
  {
    path:'/ums',
    component: Layout,
    redirect: '/ums/admin',
    name: 'ums',
    meta: {title: '权限', icon: 'ums'},
    children: [
      {
        path: 'admin',
        name: 'admin',
        component: () => import('@/views/ums/admin/index'),
        meta: {title: '用户列表', icon: 'ums-admin'}
      },
      {
        path: 'role',
        name: 'role',
        component: () => import('@/views/ums/role/index'),
        meta: {title: '角色列表', icon: 'ums-role'}
      },
      {
        path: 'allocMenu',
        name: 'allocMenu',
        component: () => import('@/views/ums/role/allocMenu'),
        meta: {title: '分配菜单'},
        hidden: true
      },
      {
        path: 'allocResource',
        name: 'allocResource',
        component: () => import('@/views/ums/role/allocResource'),
        meta: {title: '分配资源'},
        hidden: true
      },
      {
        path: 'menu',
        name: 'menu',
        component: () => import('@/views/ums/menu/index'),
        meta: {title: '菜单列表', icon: 'ums-menu'}
      },
      {
        path: 'addMenu',
        name: 'addMenu',
        component: () => import('@/views/ums/menu/add'),
        meta: {title: '添加菜单'},
        hidden: true
      },
      {
        path: 'updateMenu',
        name: 'updateMenu',
        component: () => import('@/views/ums/menu/update'),
        meta: {title: '修改菜单'},
        hidden: true
      },
      {
        path: 'resource',
        name: 'resource',
        component: () => import('@/views/ums/resource/index'),
        meta: {title: '资源列表', icon: 'ums-resource'}
      },
      {
        path: 'resourceCategory',
        name: 'resourceCategory',
        component: () => import('@/views/ums/resource/categoryList'),
        meta: {title: '资源分类'},
        hidden: true
      },
      {
        path: 'cache',
        name: 'cache',
        component: () => import('@/views/ums/cache'),
        meta: {title: '清除缓存', icon: 'ums'}
      },
    ]
  },
  {
    path:'/orderManage',
    component: Layout,
    redirect: '/orderManage/orderList',
    name: 'orderManage',
    meta: {title: '订货管理', icon: 'sms'},
    children: [
      {
        path: 'orderList',
        name: 'orderList',
        component: () => import('@/views/orderManage/index'),
        meta: {title: '订单列表', icon: 'sms-ad'}
      },{
        path: 'orderDetail',
        name: 'orderDetail',
        component: () => import('@/views/orderManage/orderDetail'),
        meta: {title: '订单详情', icon: 'product-list'}
      },{
        path: 'commodity',
        name: 'commodity',
        component: () => import('@/views/orderManage/commodity'),
        meta: {title: '商品管理', icon: 'product-list'}
      },{
        path: 'commodityEdit',
        name: 'commodityEdit',
        component: () => import('@/views/orderManage/commodityEdit'),
        meta: {title: '商品编辑', icon: 'product-list'}
      },{
        path: 'ship',
        name: 'ship',
        component: () => import('@/views/orderManage/ship'),
        meta: {title: '发货', icon: 'product-list'}
      },{
        path: 'modifyPrice',
        name: 'modifyPrice',
        component: () => import('@/views/orderManage/modifyPrice'),
        meta: {title: '修改价格', icon: 'product-list'}
      },{
        path: 'afterSellList',
        name: 'afterSellList',
        component: () => import('@/views/orderManage/orderList'),
        meta: {title: '售后订单列表', icon: 'product-list'}
      },{
        path: 'afterSale',
        name: 'afterSale',
        component: () => import('@/views/orderManage/orderList'),
        meta: {title: '售后订单', icon: 'product-list'}
      },{
        path: 'addOrder',
        name: 'addOrder',
        component: () => import('@/views/orderManage/addOrder'),
        meta: {title: '新增订单', icon: 'product-list'}
      }
    ]
  },
  {
    path:'/channelCenter',
    component: Layout,
    redirect: '/channelCenter/channelList',
    name: 'channelCenter',
    meta: {title: '渠道中心', icon: 'sms'},
    children: [
      {
        path: 'channelList',
        name: 'channelList',
        component: () => import('@/views/channelCenter/index'),
        meta: {title: '客户列表', icon: 'sms-ad'}
      },{
        path: 'customerDetail',
        name: 'customerDetail',
        component: () => import('@/views/channelCenter/customerDetail'),
        meta: {title: '客户详情', icon: 'product-list'}
      },{
        path: 'customerEditor',
        name: 'customerEditor',
        component: () => import('@/views/channelCenter/customerEditor'),
        meta: {title: '新增/编辑客户', icon: 'product-list'}
      },{
        path: 'review',
        name: 'review',
        component: () => import('@/views/channelCenter/review'),
        meta: {title: '审核', icon: 'product-list'}
      }
    ]
  },
  {
    path:'/operationCenter',
    component: Layout,
    redirect: '/operationCenter/operationList',
    name: 'operationCenter',
    meta: {title: '运营中心', icon: 'order'},
    children: [
      {
        path: 'operationList',
        name: 'operationList',
        component: () => import('@/views/operationCenter/index'),
        meta: {title: '品牌管理', icon: 'sms-hot'},
      },{
        path: 'paymentSettings',
        name: 'paymentSettings',
        component: () => import('@/views/operationCenter/paymentSettings'),
        meta: {title: '支付设置', icon: 'sms-coupon'}
      },{
        path: 'renovation',
        name: 'renovation',
        component: () => import('@/views/operationCenter/renovation'),
        meta: {title: '装修', icon: 'sms-subject'}
      },
      {
        path: 'salesAnalysis',
        name: 'salesAnalysis',
        component: () => import('@/views/operationCenter/salesAnalysis'),
        meta: {title: '销售分析', icon: 'sms-subject'}
      },
      {
        path: 'categoryManagement',
        name: 'categoryManagement',
        component: () => import('@/views/operationCenter/categoryManagement'),
        meta: {title: '类目管理', icon: 'sms-subject'}
      },
      {
        path: 'categoryEdit',
        name: 'categoryEdit',
        component: () => import('@/views/operationCenter/categoryEdit'),
        meta: {title: '类目编辑', icon: 'sms-subject'}
      },
      {
        path: 'renovationEdit',
        name: 'renovationEdit',
        component: () => import('@/views/operationCenter/renovationEdit'),
        meta: {title: '装修编辑', icon: 'sms-subject'}
      },{
        path: 'hot',
        name: 'hot',
        component: () => import('@/views/operationCenter/hot'),
        meta: {title: '搜索设置', icon: 'sms-hot'},
      }
    ]
  },
  {
    path:'/stockManage',
    component: Layout,
    redirect: '/stockManage/index',
    name: 'stockManage',
    meta: {title: '库存管理', icon: 'order'},
    children: [
      {
        path: 'stockList',
        name: 'stockList',
        component: () => import('@/views/stockManage/index'),
        meta: {title: '款式操作', icon: 'sms-hot'},
      },
      {
        path: 'stockListV2',
        name: 'stockListV2',
        component: () => import('@/views/stockManage/stockListV2'),
        meta: {title: '款式库存管理', icon: 'sms-hot'},
      },{
        path: 'stockupManage',
        name: 'stockupManage',
        component: () => import('@/views/stockManage/stockupManage'),
        meta: {title: '备货管理', icon: 'sms-coupon'}
      },{
        path: 'stockupAdd',
        name: 'stockupAdd',
        component: () => import('@/views/stockManage/stockupAdd'),
        meta: {title: '备货新增/编辑', icon: 'sms-subject'}
      },{
        path: 'stockStoreAdd',
        name: 'stockStoreAdd',
        component: () => import('@/views/stockManage/stockStoreAdd'),
        meta: {title: '库存管理/编辑', icon: 'sms-subject'}
      }
    ]
  },
  {path: '*', redirect: '/404', hidden: true}
]

export default new Router({
  // mode: 'history', //后端支持可开
  scrollBehavior: () => ({y: 0}),
  routes: constantRouterMap
})



// WEBPACK FOOTER //
// ./src/router/index.js